import { create } from "zustand";

type ConfirmConfig = {
  title: string;
  desc?: string;
  confirmMessage?: string;
  onConfirm?: () => void | Promise<void>;
};

type ConfirmState = {
  isOpen: boolean;
  title: string;
  desc?: string;
  confirmMessage?: string;
  onConfirm?: () => void | Promise<void>;
  openConfirm: (cfg: ConfirmConfig) => void;
  closeConfirm: () => void;
};

export const useConfirmStore = create<ConfirmState>((set, get) => {
  return {
    isOpen: false,
    title: "",
    desc: undefined,
    confirmMessage: "",
    onConfirm: undefined,
    onCancel: undefined,

    openConfirm: (cfg) =>
      set({
        isOpen: true,
        title: cfg.title,
        desc: cfg.desc,
        confirmMessage: cfg.confirmMessage,
        onConfirm: cfg.onConfirm,
      }),

    closeConfirm: () =>
      set({
        isOpen: false,
        title: "",
        desc: undefined,
        confirmMessage: "",
        onConfirm: undefined,
      }),
  };
});
